(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["pm-autumn-sale-toast"] && !Shopify.designMode) return;
  try {
    (() => {
    const toast = document.getElementById('pm-autumn-sale-toast');
    if (!toast) return;
    const key = 'pm-autumn-sale-toast-2026-15s';
    let showTimer;
    let exitTimer;
    let hideTimer;
    let deadline = 0;
    const clearTimers = () => {
      window.clearTimeout(showTimer);
      window.clearTimeout(exitTimer);
      window.clearTimeout(hideTimer);
    };
    const show = (resuming) => {
      if (!resuming) {
        deadline = Date.now() + 15000;
        try { sessionStorage.setItem(key, String(deadline)); } catch {}
      }
      const remaining = deadline - Date.now();
      if (remaining <= 0) {
        toast.hidden = true;
        toast.dataset.state = 'already-seen';
        return;
      }
      toast.dataset.expiresAt = String(deadline);
      if (resuming) toast.style.transition = 'none';
      toast.hidden = false;
      toast.dataset.state = 'visible';
      toast.getBoundingClientRect();
      toast.classList.add('is-visible');
      if (resuming) {
        toast.getBoundingClientRect();
        toast.style.removeProperty('transition');
      }
      exitTimer = window.setTimeout(() => {
        toast.classList.remove('is-visible');
        toast.dataset.state = 'hiding';
        hideTimer = window.setTimeout(() => {
          toast.hidden = true;
          toast.dataset.state = 'hidden';
        }, 300);
      }, remaining);
    };
    const initialise = () => {
      clearTimers();
      toast.hidden = true;
      toast.classList.remove('is-visible');
      try { deadline = Number(sessionStorage.getItem(key)) || 0; } catch {}
      if (deadline > 0) {
        show(true);
      } else {
        toast.dataset.state = 'waiting';
        showTimer = window.setTimeout(() => show(false), 1000);
      }
    };
    window.addEventListener('pagehide', () => {
      clearTimers();
      toast.hidden = true;
      toast.dataset.state = 'hidden';
    });
    window.addEventListener('pageshow', (event) => {
      if (event.persisted) initialise();
    });
    initialise();
  })();
  } catch(e) { console.error(e); }
})();

})();
